import classnames from 'classnames/bind'
import { isEmpty, max, min } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { setModalHorizontalPosition } from '../supports/modal_style_helper'
import styles from './toast.module.scss'

const cx = classnames.bind(styles)

const CSS_ANIMATION_DURATION = 200
const CHARACTER_READ_TIME = 200
export const TOAST_DISPLAY_MIN_TIME = 5000
const TOAST_DISPLAY_MAX_TIME = 10000

class ToastManager {
  constructor() {
    this.toast = null
  }

  setToast(toast) {
    if (this.toast) {
      throw new Error('toast is already initialized')
    } else {
      this.toast = toast
    }
  }

  notify(message) {
    if (this.toast) {
      this.toast.notify(message)
    }
  }
}

const manager = new ToastManager()

export default class Toast extends Component {
  constructor(props) {
    super(props)

    this.state = {
      visibility: false,
      showMessage: false,
      message: null
    }
  }

  static notify(message) {
    manager.notify(message)
  }

  componentDidMount() {
    manager.setToast(this)

    const { message } = this.props

    this.notify(message)
  }

  replace(message) {
    this.hide().then(() => {
      this.show(message)
    })
  }

  show(message) {
    return Promise.resolve()
      .then(() => {
        const { displayTimeoutId } = this.state

        clearTimeout(displayTimeoutId)

        this.setState({
          message,
          visibility: true
        })
      })
      .then(() => {
        setModalHorizontalPosition(this.modal)
      })
      .delay(CSS_ANIMATION_DURATION)
      .then(() => {
        this.setState({
          showMessage: true
        })
      })
      .then(() => {
        const messageReadTime = message.length * CHARACTER_READ_TIME
        const waitTime = max([TOAST_DISPLAY_MIN_TIME, min([messageReadTime, TOAST_DISPLAY_MAX_TIME])])

        this.setState({
          displayTimeoutId: setTimeout(() => {
            this.hide()
          }, waitTime)
        })
      })
  }

  hide() {
    return Promise.resolve()
      .then(() => {
        const { displayTimeoutId } = this.state

        clearTimeout(displayTimeoutId)

        this.setState({
          showMessage: false
        })
      })
      .delay(CSS_ANIMATION_DURATION)
      .then(() => {
        this.setState({
          message: null,
          visibility: false
        })
      })
  }

  notify(message) {
    if (isEmpty(message)) {
      return
    }

    const { showMessage, visibility } = this.state

    if (showMessage || visibility) {
      this.replace(message)
    } else {
      this.show(message)
    }
  }

  render() {
    const { withIcon } = this.props
    const { message, showMessage, visibility } = this.state

    if (!visibility) {
      return null
    }

    return (
      <div className={cx({ toastVisible: visibility, toastHidden: !visibility })}>
        <div
          className={cx(styles.toast, { toastActive: showMessage, toastWithIcon: withIcon })}
          onClick={() => this.hide()}
          ref={ref => {
            this.modal = ref
          }}
          role="presentation"
        >
          {message}
          {withIcon ? <i className={cx('ic-close', styles.iconClose)} /> : null}
        </div>
      </div>
    )
  }
}

Toast.propTypes = {
  message: PropTypes.string,
  withIcon: PropTypes.bool
}

Toast.defaultProps = {
  message: null,
  withIcon: true
}
